export default "__VITE_ASSET__CKkc6IPd__"